import { render, staticRenderFns } from "./veBaseBanjiBzrEdit.vue?vue&type=template&id=c1239e28&scoped=true"
import script from "./veBaseBanjiBzrEdit.vue?vue&type=script&lang=js"
export * from "./veBaseBanjiBzrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1239e28",
  null
  
)

export default component.exports